import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-m-countries',
  templateUrl: './edit-m-countries.component.html',
  styleUrls: ['./edit-m-countries.component.scss']
})
export class EditMCountriesComponent implements OnInit {

  countryFormData: any = {
    name_ar: '',
    name_en: '',
  };

  countryId: string;
  currentLang: string;
  isLoading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.currentLang = this.translate.currentLang || 'en';
  }

  ngOnInit(): void {
    this.countryId = this.route.snapshot.paramMap.get('id') || '';
    this.getCountryData();
  }

  getCountryData() {
    if (this.countryId) {
      this.isLoading = true;
      this.apiService.getCountriesById(this.countryId).subscribe({
        next: (response: any) => {
          this.countryFormData = {
            name_ar: response.data?.name || '',
            name_en: response.data?.name_en || '',
          };
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Get country failed:', err);
          this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_load_countries'));
          this.isLoading = false;
        }
      });
    }
  }

  onSubmit(): void {
    if (!this.countryId) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.invalid_country_id'));
      return;
    }

    // التحقق من البيانات قبل الإرسال
    if (!this.countryFormData.name_en?.trim() || !this.countryFormData.name_ar?.trim()) {
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.please_fill_all_fields'));
      return;
    }

    console.log('Sending data - English:', this.countryFormData.name_en);
    console.log('Sending data - Arabic:', this.countryFormData.name_ar);

    this.isLoading = true;
    
    // استخدام JSON في body بدلاً من query parameters
    this.apiService.editCountries(this.countryId, this.countryFormData).subscribe({
      next: (response) => {
        console.log('Edit response:', response);
        this.toastr.success(this.translate.instant('MENU.DASHBOARD.countries_edited_successfully'));
        this.router.navigate(['/m-countries']);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Edit country failed:', err);
        this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_edit_countries'));
        this.isLoading = false;
      }
    });
  }

  cancel(): void {
    this.router.navigate(['/m-countries']);
  }
}